module.exports = __webpack_public_path__ + "static/media/pumpwhiz-1.2592ee9a.png";